"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CNAddress_1 = require("./CNAddress");
var CNAddressMulti_1 = require("./CNAddressMulti");
var CNAddressIntl_1 = require("./CNAddressIntl");
var LocaleProvider = require("@alicd/next/lib/locale-provider");
var locale_1 = require("./locale");
CNAddress_1.default.Multi = CNAddressMulti_1.default;
var CNAddressIntlWithLocale = LocaleProvider(CNAddressIntl_1.default);
CNAddressIntlWithLocale.LOCALE = locale_1.default;
CNAddress_1.default.CNUser = CNAddressIntlWithLocale;
exports.default = CNAddress_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-address@0.0.80@@alicd/crui-address/lib/index.js
// module id = 143
// module chunks = 0